import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../Store/Store";
import Prev from "../../img/PrevBlack.png"
import DeleteImg from "../../img/Delete.png"
import axios from "axios";
import MenuEx from "../../img/naga.png"
import { useCookies } from 'react-cookie';
import { useLocation } from "react-router-dom";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
    `,
    HeaderWrap:styled.div`
        width:100%;
        height:56px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        z-index:3;
        background-color:#ffffff;
    `,
        Header:styled.div`
            width:90%;
            height:56px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            HeaderText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
        Nothing:styled.div`
            width:100%;
            height:56px;
        `,
        ContentWrap:styled.div`
            width:90%;
            height:auto;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:column;
            margin-top:20px;
        `,
            ExplainBox:styled.div`
                width:100%;
                height:auto;
                margin-bottom:20px;
                display:flex;
                justify-content:center;
                align-items:flex-start;
                flex-direction:column;
            `,
                ExplainTitle:styled.p`
                    font-size:18px;
                    font-weight:500;
                    color:#111111;
                    margin:0px;
                    font-family:'PreFont';
                `,
                ExplainText:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:#767676;
                    margin:0px;
                    font-family:'PreFont';
                `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,

            ContentBox:styled.div`
                width:100%;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
                border:1px solid #EDEDED;
                border-radius:10px;
                margin-bottom:10px;
            `,
            OrderWrap:styled.div`
                    width:100%;
                    height:auto;
                    padding-left:0px;
                    padding-right:0px;
                    padding-top:16px;
                    padding-bottom:16px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                `,
                OrderBox:styled.div`
                    width:90%;
                    height:84px;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                MenuImg:styled.div`
                    width:103px;
                    height:80px;
                `,
                    Img:styled.img`
                        width:100%;
                        height:100%;
                        border-radius:10px;
                        border:1px solid #787878;
                    `,
                Content:styled.div`
                    width:calc(100% - 113px);
                    height:84px;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    flex-direction:row;
                `,
                    LeftContent:styled.div`
                        width:65%;
                        height:65px;
                        display:flex;
                        justify-content:space-between;
                        align-items:flex-start;
                        flex-direction:column;
                    `,
                    RightContent:styled.div`
                        width:35%;
                        height:100%;
                        display:flex;
                        justify-content:flex-end;
                        align-items:flex-end;
                        flex-direction:column;
                    `,
                        CancelRequestBtn:styled.div`
                            
                            z-index:3;
                            width:52px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #B7B7B7;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                            &:hover{
                                opacity:50%;
                                transition:0.5s;
                            }
                        `,
                            CancelRequestBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#767676;
                                letter-spacing:-0.33px;
                            `,
                        CancelIngBtn:styled.div`
                            width:63px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #2277F6;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                        `,
                            CancelIngBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#2277F6;
                                letter-spacing:-0.33px;
                            `,
                        CancelEndBtn:styled.div`
                            width:54px;
                            height:23px;
                            border-radius:28px;
                            border:1px solid #1A76FF;
                            display:flex;
                            justify-content:center;
                            align-items:center;
                            flex-direction:row;
                        `,
                            CancelEndBtnText:styled.p`
                                font-size:11px;
                                font-weight:400;
                                margin:0px;
                                font-family:'PreFont';
                                color:#1A76FF;
                                letter-spacing:-0.33px;
                            `,
                        ContentHText:styled.p`
                            font-size:16px;
                            font-weight:600;
                            margin:0px;
                            font-family:'PreFont';
                            color:#181818;
                            letter-spacing:-0.33px;
                        `,
                        ContentText:styled.p`
                            font-size:16px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#181818;
                            letter-spacing:-0.33px;
                        `,
                        ContentGrayText:styled.p`
                            font-size:14px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#929292;
                            letter-spacing:-0.33px;
                        `,
                        ContentDateText:styled.p`
                            font-size:13px;
                            font-weight:400;
                            margin:0px;
                            font-family:'PreFont';
                            color:#929292;
                            letter-spacing:-0.33px;
                        `,

}
const Cancel=()=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);
    const location = useLocation();
    const navigate = useNavigate();
    const {
        Pocket,
        setPocket,
    } = useTokenStore()
    const { order } = location.state || {};


    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)

    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
      const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
  
      setRestaurant_PK(first);
      setTable_PK(second);
            console.log(IDcookies["restaurant_id"])
        } else {
            console.log("ID 값이 없습니다.");
        }
    }, [IDcookies["restaurant_id"]]);



    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });

    
    const CancelApi = async () => {
        console.log(order.id)
        if(order !== undefined){
            alert("취소요청이 완료되었습니다.")
            navigate(-2);
            try {
                const response = await axiosInstance.post("orders/order-cancel-request/", {
                    "order":order.id,
                    "restaurant": Restaurant_PK
                });
                console.log(response.data); // 요청에 대한 응답 데이터 출력

            } catch (error) {
                console.error(error); // 요청에 실패한 경우 에러 메시지 출력
                alert("취소수락을 기다려주세요")
            }
        }else{
            alert("취소수락을 기다려주세요")
        }
    };
    // 주문취소신청 api
    


    const [OrderQuantity, setOrderQuantity] = useState({
        "KR":"수량",
        "EN":"Quantity",
        "CN":"数量",
        "JP":"数量",
        "FR":"quantité",
        "SP":"cantidad",
        "GR":"Menge",
        "RU":"количество"
    })
    

    const [Won, setWon] = useState({
        "KR":"원",
        "EN":"won",
        "CN":"won",
        "JP":"ウォン",
        "FR":"won",
        "SP":"won",
        "GR":"won",
        "RU":"won"
    })

    const [ExTitle, setExTitle] = useState({
        "KR":"선택하신 메뉴의 취소요청을 하시겠어요?",
        "EN":"Do you want to request the cancellation of the selected menu?",
        "CN":"您要取消所选菜单吗？",
        "JP":"選択したメニューのキャンセルを追加メニューしますか？",
        "FR":"Voulez-vous demander l'annulation du menu sélectionné ?",
        "SP":"¿Desea solicitar la cancelación del menú seleccionado?",
        "GR":"Möchten Sie die Stornierung des ausgewählten Menüs anfordern?",
        "RU":"Вы хотите запросить отмену выбранного меню?"
    })

    const [ExText1, setExText1] = useState({
        "KR":"사장님이 환불요청을 수락하면 환불절차가 진행돼요",
        "EN":"If the owner accepts the refund request, the refund process will proceed.",
        "CN":"如果老板接受退款请求，退款流程将开始。",
        "JP":"店主が返金要求を承認すると、返金手続きが進みます。",
        "FR":"Si le propriétaire accepte la demande de remboursement, le processus de remboursement sera lancé.",
        "SP":"Si el propietario acepta la solicitud de reembolso, se procederá con el proceso de reembolso.",
        "GR":"Wenn der Inhaber die Rückerstattungsanfrage akzeptiert, wird der Rückerstattungsprozess fortgesetzt.",
        "RU":"Если владелец примет запрос на возврат, процесс возврата будет запущен."
    })

    const [ExText2, setExText2] = useState({
        "KR":"환불은 영업일 기준 3~5일 소모돼요",
        "EN":"The refund takes 3 to 5 business days.",
        "CN":"退款需要3至5个工作日",
        "JP":"返金には営業日で3～5日かかります",
        "FR":"Le remboursement prend 3 à 5 jours ouvrables",
        "SP":"El reembolso tarda de 3 a 5 días hábiles",
        "GR":"Die Rückerstattung dauert 3 bis 5 Werktage",
        "RU":"Возврат занимает от 3 до 5 рабочих дней"
    })

    const [Title, setTitle] = useState({
        "KR":"취소요청",
        "EN":"Cancel",
        "CN":"取消",
        "JP":"キャンセル",
        "FR":"Annulation",
        "SP":"Cancelar",
        "GR":"Storno",
        "RU":"Отмена"
    })

    const [CancelRequest, setCancelRequest] = useState({
        "KR":"취소요청",
        "EN":"Cancel",
        "CN":"取消",
        "JP":"キャンセル",
        "FR":"Annulation",
        "SP":"Cancelar",
        "GR":"Storno",
        "RU":"Отмена"
    })

    function formatDateTime(dateTimeString) {
        const date = new Date(dateTimeString);
    
        // 날짜 포맷: 두 자릿수로 맞춤
        const year = String(date.getFullYear()).slice(2); // 연도 뒤 두 자리
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1)
        const day = String(date.getDate()).padStart(2, '0'); // 일
        const hours = String(date.getHours()).padStart(2, '0'); // 시간
        const minutes = String(date.getMinutes()).padStart(2, '0'); // 분
    
        return `${month}.${day} ${hours}:${minutes}`;
    }

    // orders/order-cancel-request/
    return(
            <Styled.Wrap>
                <Styled.HeaderWrap>
                    <Styled.Header>
                        <Styled.PrevBtn onClick={() => navigate(-2)}>
                            <Styled.PrevImg src={Prev}/>
                        </Styled.PrevBtn>
                        <Styled.HeaderText>{Title[Langcookies["PageLang"]]}</Styled.HeaderText>
                        <Styled.PrevBtn />
                    </Styled.Header>
                </Styled.HeaderWrap>
                <Styled.ContentWrap>
                    <Styled.ExplainBox>
                        <Styled.ExplainTitle>{ExTitle[Langcookies["PageLang"]]}</Styled.ExplainTitle>
                        <Styled.ExplainText>{ExText1[Langcookies["PageLang"]]}</Styled.ExplainText>
                        <Styled.ExplainText>{ExText2[Langcookies["PageLang"]]}</Styled.ExplainText>
                    </Styled.ExplainBox>

                    {/* <Styled.ContentBox>
                        <Styled.OrderBox>
                            <Styled.MenuImg>
                                <Styled.Img src={MenuEx}/>
                            </Styled.MenuImg>
                            <Styled.Content>
                                <Styled.LeftContent>
                                    <Styled.ContentHText>나가사키짬뽕</Styled.ContentHText>
                                    <Styled.ContentText>24,500{Won[Langcookies["PageLang"]]}</Styled.ContentText>
                                    <Styled.ContentGrayText>{OrderQuantity[Langcookies["PageLang"]]} : 2</Styled.ContentGrayText>
                                </Styled.LeftContent>
                                <Styled.RightContent>
                                    
                                    <Styled.ContentDateText>24.10.7 17:30</Styled.ContentDateText>
                                </Styled.RightContent>
                            </Styled.Content>
                        </Styled.OrderBox>
                    </Styled.ContentBox> */}
                    <Styled.ContentBox>
                        {order.items.map((item, itemIndex) => (
                            <Styled.OrderWrap>
                                <Styled.OrderBox key={item.menu}>
                                    <Styled.MenuImg>
                                        <Styled.Img src={`https://zzikgomainapi.co.kr${item.menu_info.image}`} alt={item.menu_info.names.KR} />
                                    </Styled.MenuImg>
                                    <Styled.Content>
                                        <Styled.LeftContent>
                                            <Styled.ContentHText>{item.menu_info.names[Langcookies["PageLang"]]}</Styled.ContentHText>
                                            <Styled.ContentText>
                                                {item.menu_info.price * item.quantity}{Won[Langcookies["PageLang"]]}
                                            </Styled.ContentText>
                                            <Styled.ContentGrayText>
                                                {OrderQuantity[Langcookies["PageLang"]]} : {item.quantity}
                                            </Styled.ContentGrayText>
                                        </Styled.LeftContent>
                                        <Styled.RightContent>
                                            {/* 첫 번째 item에만 CancelRequestBtn을 표시 */}
                                            {itemIndex === order.items.length - 1 && (
                                                <Styled.ContentDateText>
                                                    {formatDateTime(order.ordered_at) || "No Date"} {/* ordered_at이 없으면 기본 텍스트 표시 */}
                                                </Styled.ContentDateText>
                                            )}
                                        </Styled.RightContent>
                                    </Styled.Content>
                                </Styled.OrderBox>
                            </Styled.OrderWrap>
                        ))}
                    </Styled.ContentBox>
                </Styled.ContentWrap>
                
                <Styled.Footer>
                    <Styled.CallBtn onClick={()=>{
                        CancelApi()
                    }}>
                        <Styled.BtnText>{CancelRequest[Langcookies["PageLang"]]}</Styled.BtnText>
                    </Styled.CallBtn>
                </Styled.Footer>
            </Styled.Wrap>
    )
    
}
export default Cancel